import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=bcd2c416&scoped=true&lang=pug&"
import script from "./Show.vue?vue&type=script&lang=ts&"
export * from "./Show.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd2c416",
  null
  
)

export default component.exports